/** @jsxImportSource @emotion/react */
import { useMemo } from "react";

import { colors, getTime, getPlayingTimes } from "../functions/Helper.js";

import { View, Text } from "@react-pdf/renderer";

export default function PlayingTimeTablePDF({
  periods,
  periodLength,
  players,
  minutes,
}) {
  let sortedPlayers = useMemo(() => {
    const playingTimes = getPlayingTimes(players, minutes);

    let playersWithPlayingTime = players.map((player) => {
      let time = playingTimes.find((x) => x.id === player.id)?.time ?? 0;
      return { ...player, time };
    });

    return playersWithPlayingTime.sort((a, b) => b.time - a.time);
  }, [players, minutes]);

  return (
    <View>
      {sortedPlayers.map((player) => {
        return (
          <View
            style={{ height: "15px", marginBottom: 5, flexDirection: "row" }}
            key={player.id}
          >
            <View
              style={{
                flexBasis: 60,
                display: "flex",
                justifyContent: "center",

                //backgroundColor: "grey",
              }}
            >
              <Text style={{ fontSize: 8 }}>{player.name}:</Text>
            </View>
            <View style={{ flex: 1, flexDirection: "row", display: "flex" }}>
              <View
                style={{
                  flex: player.time,
                  backgroundColor: colors[player.colorId],
                }}
              >
                <View
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    flex: 1,
                  }}
                >
                  <Text
                    style={{
                      verticalAlign: "middle",
                      color: "white",
                      fontSize: 8,
                      fontWeight: "bold",
                      paddingLeft: 10,
                    }}
                  >
                    {getTime(player.time)}{" "}
                  </Text>
                </View>
              </View>
              <View
                style={{
                  backgroundColor: "#f0f0f0",
                  flex: periodLength * periods - player.time,
                }}
              ></View>
            </View>
          </View>
        );
      })}
    </View>
  );
}
